import { z } from 'zod'

export const inviteMemberSchema = z.object({
  email: z.string().email('Invalid email address'),
})

export type InviteMemberDto = z.infer<typeof inviteMemberSchema>
